/** All available exchange protocols for PACS converters */
export enum ConverterExchangeProtocolEnum {
  /** FRM test mock converter (for tests, available only on admin tenant) */
  TEST_MOCK_CONVERTER = 'TEST_MOCK_CONVERTER',
  /** "Iron Logic" converter protocol */
  IRON_LOGIC = 'IRON_LOGIC',
}
